import { render, staticRenderFns } from "./product-bracket-prices.vue?vue&type=template&id=2848e727&"
import script from "./product-bracket-prices.vue?vue&type=script&lang=js&"
export * from "./product-bracket-prices.vue?vue&type=script&lang=js&"
import style0 from "./product-bracket-prices.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports